import AddSitePage from './AddSite';
import { createAddSiteHandle } from './handle';

export default {
  Component: AddSitePage,
  createHandle: createAddSiteHandle
};
